<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent="onSubmit">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Number</label>
          <input
            name="number"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('number')}"
            type="text"
            class="form-control"
            placeholder="Input unit number"
            v-model="form.number"
          >
          <b-form-feedback>{{ errors.first('number') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label>Type</label>
          <input
            name="type"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('type')}"
            type="text"
            class="form-control"
            placeholder="Input unit type"
            v-model="form.type"
          >
          <b-form-feedback>{{ errors.first('type') }}</b-form-feedback>
        </div>
      </div>
      <hr>
      <b-button type="submit" variant="primary">Add</b-button>
      <b-button
        @click="section = 'units'"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </div>
</template>
<script>
export default {
  name: 'add_order_unit',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      form: {
        number: null,
        type: null,
      },
    };
  },
  computed: {
    orderId() {
      return this.$route.params.orderId;
    },
  },
  watch: {
    section(newSection) {
      this.$router.push(`/shipment_md/orders/${this.orderId}/${newSection}`);
    },
  },
  methods: {
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          const { form } = this;
          form.orderId = this.orderId;
          this.$store.dispatch('shipment_md/orders/CREATE_UNIT', this.form).then(() => {
            this.$router.push(`/shipment_md/orders/${this.orderId}/units`);
          });
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/detail/AddUnit.vue